import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { useTranslate } from '@tolgee/react';

function FaqUnsupported(props: BaseMsgProps) {
  const { t } = useTranslate();

  return <MessageExtendComplex {...props} content={<Container>{t('faqUnsupported')}</Container>} />;
}

const Container = styled.div`
  max-width: 450px;
  padding: 8px 12px;
  border-radius: 4px;
  background: #ffe9e5;
`;

export default FaqUnsupported;
